import { render, staticRenderFns } from "./fenge.vue?vue&type=template&id=e1f70dd2&scoped=true&"
import script from "./fenge.vue?vue&type=script&lang=ts&"
export * from "./fenge.vue?vue&type=script&lang=ts&"
import style0 from "./fenge.vue?vue&type=style&index=0&id=e1f70dd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f70dd2",
  null
  
)

export default component.exports